import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import { FilePicker } from 'react-file-picker'
import { prefix } from '../../../i18n'
import ReactSelect from 'react-select'
import { InvoiceService } from '../../../services'
import { Link } from 'react-router-dom'
import Modal from '../shared/Modal'
import InvoiceProductFormContainer from './InvoiceProductFormContainer'

const tInvoice = prefix('invoice')

export default class InvoiceForm extends Component {
  state = {
    number: '',
    saleType: null,
    document: null,
    thereIsInvoice: false,
    errorToGetInvoice: null,
    invoiceDate: new Date(),
    products: [],
    showProductModal: false,
  }

  updateState = (stateName, mapper) => (data) => {
    this.setState({ [stateName]: mapper ? mapper(data) : data })
  }

  eventMapper = (e) => e.target.value

  handleSubmit = (e) => {
    e.preventDefault()
    const { number, invoiceDate, saleType, document, products } = this.state
    if (!this.state.errorToGetInvoice && !this.state.thereIsInvoice) {
      this.props.onSubmit({ number, invoiceDate, saleType, document: document || {}, products })
    } else {
      if (this.state.thereIsInvoice) {
        window.alert('Já existe factura com mesmo número')
      } else if (this.state.errorToGetInvoice) {
        window.alert('Ocorreu um erro para verificar número de factura')
      }
    }
  }

  checkExistentInvoice = (event) => {
    event.preventDefault()
    const { campaign, client } = this.props
    if (!client) return
    InvoiceService.getInvoiceByNumber({
      campaignId: campaign.slug,
      clientId: client.slug,
      invoiceNumber: this.state.number,
    })
      .then(response => {
        if (response.status === 200 && response.data.id) {
          this.setState({ thereIsInvoice: true, errorToGetInvoice: null })
        } else {
          this.setState({ thereIsInvoice: false, errorToGetInvoice: null })
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          this.setState({ thereIsInvoice: false, errorToGetInvoice: null })
        } else {
          this.setState({ thereIsInvoice: false, errorToGetInvoice: error })
        }
      })
  }

  componentDidUpdate(oldProps) {
    const { saleTypes } = this.props
    if (oldProps.saleTypes !== saleTypes) {
      this.setState({ saleType: saleTypes.length > 0 ? saleTypes[0] : null })
    }
  }

  componentDidMount() {
    const { saleTypes, invoice } = this.props
    const defaultValue = saleTypes.length > 0 ? saleTypes[0] : null
    if (invoice === undefined) {
      this.setState({ saleType: defaultValue })
    } else {
      this.setState({
        saleType: saleTypes.find(i => i.name === invoice.sale_type) || defaultValue,
        number: invoice.invoice_number,
        invoiceDate: new Date(invoice.invoice_date),
      })
    }
  }

  handleProductAdd = (productData) => {
    const { onProductAdd } = this.props
    if (onProductAdd) {
      // Edit/draft mode: delegate to parent which calls the API
      onProductAdd(productData)
      this.setState({ showProductModal: false })
      return
    }
    // Create mode: accumulate locally until the whole form is submitted
    const { selectedSaleType, selectedBrand, selectedCategory, selectedProduct, quantity } = productData
    const product = {
      sale_type: selectedSaleType,
      brand: selectedBrand,
      category: selectedCategory,
      product_code: selectedProduct,
      quantity: Number(quantity),
    }
    this.setState(function(prevState) {
      return { products: prevState.products.concat([product]), showProductModal: false }
    })
  }

  handleProductRemove = (index) => {
    this.setState(function(prevState) {
      return { products: prevState.products.filter(function(_, i) { return i !== index }) }
    })
  }

  // Edit/draft mode only: save header fields without submitting for approval
  handleSaveDraft = () => {
    const { number, invoiceDate, saleType, document } = this.state
    this.props.onSaveDraft({ number, invoiceDate, saleType, document: document || {} })
  }

  render() {
    const { campaign, saleTypes, errors, serverProducts, onProductRemove, onSaveDraft, onSubmitFatura, invoice } = this.props
    const { number, saleType, document, invoiceDate, products, showProductModal } = this.state
    const isEditMode = Boolean(serverProducts)
    const displayProducts = isEditMode ? serverProducts : products

    return (
      <div className="invoice-form-page">
        <Link to="/invoice/created" className="invoice-form-back">← Voltar</Link>

        <h4 className="invoice-form-title">{isEditMode ? 'Editar rascunho' : 'Registar fatura'}</h4>

        {/* ── Header fields ── */}
        <div className="invoice-form-card">
          <div className="invoice-form-row">
            <div className="invoice-form-field">
              <label className="invoice-form-label">Nº Fatura</label>
              <input
                className="invoice-form-input"
                type="text"
                placeholder="Insira o nº da fatura"
                value={number}
                onChange={this.updateState('number', this.eventMapper)}
                onBlur={this.checkExistentInvoice}
              />
              {errors && errors.invoice_number && <p className="invoice-error">{errors.invoice_number.join(',')}</p>}
            </div>
            <div className="invoice-form-field">
              <label className="invoice-form-label">Tipo de venda</label>
              <ReactSelect
                onChange={this.updateState('saleType')}
                options={saleTypes}
                getOptionLabel={function(o) { return o.name }}
                getOptionValue={function(o) { return o.id }}
                value={saleType}
                placeholder="Selecionar"
                className="invoice-form-select"
                classNamePrefix="invoice-select"
                noOptionsMessage={function() { return 'Sem opções' }}
              />
              {errors && errors.sale_type && <p className="invoice-error">{errors.sale_type.join(',')}</p>}
            </div>
            <div className="invoice-form-field">
              <label className="invoice-form-label">Data da fatura</label>
              <DatePicker
                selected={invoiceDate}
                onChange={this.updateState('invoiceDate')}
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/aaaa"
                className="invoice-form-input"
              />
              {errors && errors.invoice_date && <p className="invoice-error">{errors.invoice_date.join(',')}</p>}
            </div>
          </div>
        </div>

        {/* ── Document section ── */}
        <div className="invoice-form-section">
          <h5 className="invoice-form-section-title">Documento da fatura</h5>
          <p className="invoice-form-section-subtitle">Formatos aceites: PNG, JPG, JPEG ou PDF</p>
          <div className="invoice-form-card">
            {isEditMode && invoice && invoice.attachment ? (
              <a className="gl-button secondary medium body-m" href={invoice.attachment.url} target="_blank" rel="noopener noreferrer" download>
                Download Anexo
              </a>
            ) : (
              <FilePicker
                extensions={['jpg', 'jpeg', 'png', 'pdf']}
                onChange={this.updateState('document')}
                onError={function() {}}
              >
                <button type="button" className="gl-button secondary medium body-m">
                  {document ? document.name : 'Carregar fatura'}
                </button>
              </FilePicker>
            )}
            {errors && errors.attachment && <p className="invoice-error">{errors.attachment.join(',')}</p>}
          </div>
        </div>

        {/* ── Products section ── */}
        <div className="invoice-form-section">
          <h5 className="invoice-form-section-title">Produtos</h5>
          <div className="invoice-form-card">
            {displayProducts.length > 0 && (
              <div className="invoice-form-products-list">
                {displayProducts.map(function(p, i) {
                  // Server products (edit mode) have shape: { id, product: { external_identifier }, quantity }
                  // Local products (create mode) have shape: { brand, category, product_code, quantity }
                  var label = isEditMode
                    ? (p.product && p.product.external_identifier)
                    : (p.product_code && p.product_code.external_identifier)
                  return (
                    <div key={i} className="invoice-form-product-row">
                      {!isEditMode && <span className="invoice-form-product-cell">{p.brand && p.brand.name}</span>}
                      <span className="invoice-form-product-cell">{label}</span>
                      <span className="invoice-form-product-cell">Qtd: {p.quantity}</span>
                      <button
                        type="button"
                        className="invoice-form-product-remove"
                        onClick={isEditMode
                          ? function() { onProductRemove(p) }.bind(this)
                          : function() { this.handleProductRemove(i) }.bind(this)
                        }
                      >×</button>
                    </div>
                  )
                }.bind(this))}
              </div>
            )}
            <button
              type="button"
              className="gl-button secondary medium body-m"
              onClick={function() { this.setState({ showProductModal: true }) }.bind(this)}
            >
              Adicionar produto
            </button>
          </div>
        </div>

        {/* ── Bottom actions ── */}
        <div className="invoice-form-actions">
          <button type="button" className="gl-button terciary medium body-m" onClick={onSaveDraft ? this.handleSaveDraft : this.handleSubmit}>
            Guardar rascunho
          </button>
          <button type="button" className="gl-button primary medium body-m" onClick={onSubmitFatura || this.handleSubmit}>
            Enviar fatura
          </button>
        </div>

        {/* ── Add product modal ── */}
        <Modal
          show={showProductModal}
          untoggle={function() { this.setState({ showProductModal: false }) }.bind(this)}
          large
        >
          <div className="gl2026-modal__header">
            <h5 className="gl2026-modal__title">Adicionar produto</h5>
            <button
              type="button"
              className="gl2026-modal__close"
              onClick={function() { this.setState({ showProductModal: false }) }.bind(this)}
              aria-label="Fechar"
            >×</button>
          </div>
          <InvoiceProductFormContainer
            campaign={campaign}
            createMode
            onSubmit={this.handleProductAdd}
            onCancel={function() { this.setState({ showProductModal: false }) }.bind(this)}
          />
        </Modal>
      </div>
    )
  }
}
